class ScrollTop {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const toTopButton = document.querySelector(".s-contact__toTop-president");

    toTopButton.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth', 
      });
    });

  }
}